import { ADMIN_API_BASE } from "./adminApiConfig";
import adminRequest from "./adminRequest";
import { AdminParticipantEntry } from "./adminTypes";

export interface SearchParticipantsResponse {
  code: number;
  message: string;
  data: AdminParticipantEntry[];
}

const searchParticipants = async (params: {
  phone?: string;
  code?: string;
}): Promise<SearchParticipantsResponse> => {
  try {
    return await adminRequest<SearchParticipantsResponse>({
      method: "GET",
      url: `${ADMIN_API_BASE}/api/admin/participants`,
      params: { phone: params.phone, code: params.code },
    });
  } catch (error) {
    return { code: 500, message: "Greška", data: [] };
  }
};

export default searchParticipants;
